export const Environment = {
  /**
     * Define a quantidade de linhas a ser carregada por padrão nas listagens
     */
  LIMITE_DE_LINHAS: 200,
  LIMITE_DE_LINHASSMALL: 11,
  LIMITE_DE_CADASTRO: 200,
  /**
     * Placeholder exibido nas inputs
     */
  INPUT_DE_BUSCA: 'Pesquisar...',
  /**
     * Texto exibido quando nenhum registro é encontrado em uma listagem
     */
  LISTAGEM_VAZIA: 'Nenhum registro encontrado.',
  /**
     * Url base de consultado dos dados dessa aplicação
     */

   //URL_BASE: window.env.REACT_APP_URL_BASE,
   URL_BASECADASTRO: window.env.REACT_APP_URL_BASECADASTRO,
   URL_BASESOLICITACAO: window.env.REACT_APP_URL_BASESOLICITACAO,
   URL_IMGFUNCIONARIO: window.env.REACT_APP_URL_IMGFUNCIONARIO,
   URL_IMGUSUARIOS: window.env.REACT_APP_URL_IMGUSUARIOS,
   URL_BASEESTOQUE: window.env.REACT_APP_URL_BASEESTOQUE,
   URL_IMGPATRIMONIO: window.env.REACT_APP_URL_IMGPATRIMONIO,
};



